import { Avatar, Space } from "antd";
import EllipsisText from "components/EllipsisText";

const columns = (workers_options = []) => [
  {
    title: "Pracownik",
    dataIndex: "user_id",
    sortable: true,
    searchable: true,
    search_method: "in",
    search_component: "select",
    options: workers_options,
    width: 300,
    render: (_, { user }) =>
      user?.id ? (
        <Space>
          <Avatar style={{ backgroundColor: user?.color }}>
            {user?.initials}
          </Avatar>
          <EllipsisText text={user?.full_name} limit={20} />
        </Space>
      ) : (
        "-"
      ),
  },
  {
    title: "Treść",
    dataIndex: "content",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { content }) => (
      <EllipsisText text={content} limit={150} />
    ),
  },
];

export default columns;
